import { getFieldAllocation } from '../../backend/entryPoints/getFieldAllocation';
import { useEffect, useState } from 'react';
import { getMatchData } from '../../backend/entryPoints/getMatchDataFromServer';
import { MatchViewModel, MatchViewModelSchema } from '../../backend/entryPoints/mapper/mapToMatchViewModel';
import { useTranslation } from 'react-i18next';

import '../standing/standing.css';

function OtherFieldScoreInfo(props: { field: string }) {
    const { t } = useTranslation();

    const [match, setMatch] = useState<MatchViewModel | null>(null);

    useEffect(() => {
        setInterval(() => {
            loadCurrentFieldAllocationAndMatch();
        }, 10000);
    }, []);

    const loadCurrentFieldAllocationAndMatch = () => {
        getFieldAllocation(props.field)
            .then((response) => response.text().then((data) => loadMatchDataFromStorage(data)))
            .catch((err) => console.error(err));
    };

    const loadMatchDataFromStorage = (matchName: string) => {
        getMatchData(matchName).then((response) =>
            response
                .text()
                .then((body) => mapAndSetMatch(MatchViewModelSchema.parse(JSON.parse(body))))
                .catch((err) => console.error(`Unexpected error occurred: ${err}`))
        );
    };

    const mapAndSetMatch = (matchViewModel: MatchViewModel) => {
        setMatch(matchViewModel);
    };

    return (
        <div className={'table-container-small-info'}>
            <div className={'match-mode-div'}>
                <span>
                    {t('court')} {props.field}
                </span>
            </div>
            <table className={'table-container-border'}>
                <tbody>
                    <tr>
                        <td className={'align-middle td-padding-5'}>
                            <span>{match?.home_team.replaceAll(/ /g, '').slice(0, 3)}</span>
                        </td>
                        {match?.games.map((game, idx) => (
                            <td key={`home-${idx}`} className={'align-middle td-padding-5 table-border-left'}>
                                {game.home_points}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <td className={'align-middle td-padding-5'}>
                            {match?.guest_team.replaceAll(/ /g, '').slice(0, 3)}
                        </td>
                        {match?.games.map((game, idx) => (
                            <td key={`guest-${idx}`} className={'align-middle td-padding-5 table-border-left'}>
                                {game.guest_points}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default OtherFieldScoreInfo;
